import Vue from 'vue';
import Router from 'vue-router';
//main
import Console from './Console.vue';
import Consolenew from './Console_new.vue';
import MainPage from './MainPage.vue';
import Login from './Login.vue';
//system
import Module from './views/system/Module.vue';
import Module_Detail from './views/system/Module_Detail.vue';
import Function from './views/system/Function.vue';
import Function_Detail from './views/system/Function_Detail.vue';
import Role from './views/system/Role.vue';
import Role_Detail from './views/system/Role_Detail.vue';
import Role_Fun from './views/system/Role_Fun.vue';
import Organization from './views/system/Organization.vue';
import User from './views/system/User.vue';
import User_Detail from './views/system/User_Detail.vue';
import Updatepwd from './views/system/updatepwd.vue';
import Personal from './views/system/personal.vue';
//plan
import plan_index from './views/plan/index.vue';
import plan_index_Detail from './views/plan/index_Detail.vue';
import plan_graduates from './views/plan/graduates.vue';
import plan_graduates_Detail from './views/plan/graduates_Detail.vue';
import plan_open from './views/plan/open.vue';
import plan_open_Detail from './views/plan/open_Detail.vue';
import plan_postPublic from './views/plan/postpublic.vue';
import plan_inbj from './views/plan/inbj.vue';
import plan_inbj_Detail from './views/plan/inbj_Detail.vue';
import plan_soldier from './views/plan/soldier.vue';
import plan_soldier_Detail from './views/plan/soldier_Detail.vue';
import plan_reportgraduates from './views/plan/reportgraduates.vue';
import plan_reportgraduates_Detail from './views/plan/reportgraduates_Detail.vue';
import plan_reportgraduates_Sum from './views/plan/reportgraduates_Sum.vue';
import plan_reportin from './views/plan/reportin.vue';
import plan_reportinfo from './views/plan/reportinfo.vue';
import plan_reportinfo_Detail from './views/plan/reportinfo_Detail.vue';
import plan_reportout from './views/plan/reportout.vue';
import plan_reportyuan from './views/plan/reportyuan.vue';
//device
import device_info from './views/device/device_Info.vue';
import device_flow_report from './views/device/FlowReport.vue'
import device_Detail from './views/device/device_Detail.vue'
import device_order from './views/device/order.vue';
import device_realdata from './views/device/realdata.vue';
import device_orderTemp from './views/device/orderTemp.vue';
import device_version from './views/device/version.vue';
import version_Detail from './views/device/version_Detail.vue';
import Device_Binddevice from './views/device/binddevice.vue';
//AD
import AD_info from './views/AD/info.vue';
import AD_Detail from './views/AD/AD_Detail.vue';
import AD_Bindcard from './views/AD/bindcard.vue';
import AD_advertiser from './views/AD/advertiser.vue';
import advertiser_Detail from './views/AD/advertiser_Detail.vue';
//site
import site_info from './views/Site/info.vue'
import site_Detail from './views/Site/site_Detail.vue';
import site_map from './views/Site/Map.vue'
//lightbox
import lightbox_info from './views/lightbox/info.vue'
import lightbox_Detail from './views/lightbox/lightbox_Detail.vue';
import lightbox_Device from './views/lightbox/lightboxdevice.vue';
import lightbox_log from './views/lightbox/LightBox_Log.vue';
import lightbox_checkup from './views/lightbox/lightbox_checkup.vue'
import lightbox_checkup_detail from './views/lightbox/lightbox_checkup_detail.vue'
//card
import card_info from './views/card/info.vue';
import card_Detail from './views/card/card_Detail.vue';
//custom site
import site_customsite from './views/Site/custom_site.vue';
import site_customLightBox from './views/Site/custom_lightbox.vue';
import site_customDevice from './views/Site/custom_device.vue';
import site_customReport from './views/Site/custom_report.vue';
//Alert
import Alert_Data from './views/Alert/Data.vue';
import Alert_Config from './views/Alert/Config.vue';
import Alert_Config_Detail from './views/Alert/Config_detail.vue';
import Alert_Config_User from './views/Alert/Config_user.vue'
import Alert_Log from './views/Alert/Log.vue'
//flow
import Flow_Data from './views/flow/Data.vue';
import Flow_type from './views/flow/type.vue';
import type_Detail from './views/flow/type_Detail.vue';
//log
import log_worktime from './views/Log/worktime.vue'

Vue.use(Router)

export default new Router({
  //mode: 'history',
  routes: [
    { path: '/', 
      redirect: '/login' 
    },
    {
      path:'/login',
      name: 'R_login',
      component: Login
    },
    {
      path:'/console',
      component: Console,
      children:[
        {
          path:'',
          component:MainPage
        }
      ]
    },
    {
      path:'/mapconsole',
      name: 'console_new',
      component: Consolenew
    },
    //---------------------system
    {
      path:'/system/',
      name: 'system',
      component: Console,
      children:[
        {
          path:'module',
          name: 'module',
          component:Module
        },
        {
          path:'module/:type/:id?',
          name: 'Module_Detail',
          component:Module_Detail
        },
        {
          path:'Function',
          name: 'Function',
          component:Function
        },
        {
          path:'function/:type/:id?',
          name: 'Function_Detail',
          component:Function_Detail
        },
        {
          path:'organization',
          name: 'organization',
          component:Organization
        },
        {
          path:'role',
          name: 'role',
          component:Role
        },
        {
          path:'role/:type/:id?',
          name: 'Role_Detail',
          component:Role_Detail
        },
        {
          path:'role_fun/:id?',
          name: 'Role_Fun',
          component:Role_Fun
        },
        {
          path:'user',
          name: 'User',
          component:User
        },
        {
          path:'user/:type/:id?',
          name: 'User_Detail',
          component:User_Detail
        },
        {
          path:'Updatepwd',
          name: 'Updatepwd',
          component: Updatepwd
        },
        {
          path:'Personal',
          name: 'Personal',
          component: Personal
        }
      ]
    },
    //---------------------plan
    {
      path:'/plan/',
      name: 'plan',
      component: Console,
      children:[
        {
          path:'index',
          name: 'plan_index',
          component:plan_index
        },
        {
          path:'index/:type/:id?',
          name: 'plan_index_Detail',
          component:plan_index_Detail
        },
        {
          path:'graduates',
          name: 'plan_graduates',
          component:plan_graduates
        },
        {
          path:'graduates/:type/:id?',
          name: 'plan_graduates_Detail',
          component:plan_graduates_Detail
        },
        {
          path:'open',
          name: 'plan_open',
          component:plan_open
        },
        {
          path:'open/:type/:id?',
          name: 'plan_open_Detail',
          component:plan_open_Detail
        },
        {
          path:'post/public',
          name: 'plan_postPublic',
          component:plan_postPublic
        },
        {
          path:'inbj',
          name: 'plan_inbj',
          component:plan_inbj
        },
        {
          path:'inbj/:type/:id?',
          name: 'plan_inbj_Detail',
          component:plan_inbj_Detail
        },
        {
          path:'soldier',
          name: 'plan_soldier',
          component:plan_soldier
        },
        {
          path:'soldier/:type/:id?',
          name: 'plan_soldier_Detail',
          component:plan_soldier_Detail
        },
        {
          path:'report/graduates',
          name: 'plan_reportgraduates',
          component:plan_reportgraduates
        },
        {
          path:'report/graduates/detail/:type/:id?',
          name: 'plan_reportgraduates_Detail',
          component:plan_reportgraduates_Detail
        },
        {
          path:'report/graduates/sum/:type/:id?',
          name: 'plan_reportgraduates_Sum',
          component:plan_reportgraduates_Sum
        },
        {
          path:'report/in',
          name: 'plan_reportin',
          component:plan_reportin
        },
        {
          path:'report/out',
          name: 'plan_reportout',
          component:plan_reportout,
          
        },
        {
          path:'report/info',
          name: 'plan_reportinfo',
          component:plan_reportinfo
        },
        {
          path:'report/info/:type/:id?',
          name: 'plan_reportinfo_Detail',
          component:plan_reportinfo_Detail
        },
        {
          path:'report/yuan',
          name: 'plan_reportyuan',
          component:plan_reportyuan
        }
      ]
    },
    //----------------------device
    {
      path:'/device/',
      name: 'device',
      component: Console,
      children:[
        {
          path:'info',
          name: 'device_info',
          component:device_info
        },
        {
          path:'flowreport/:id',
          name: 'device_flow_report',
          component:device_flow_report
        },
        {
          path:'infoforsite/:id?',
          name: 'device_info',
          component:device_info
        },
        {
          path:'infoforsend/:dcode?',
          name: 'device_info',
          component:device_info
        },
        {
          path:'infoforbind/:lightboxid',
          name: 'device_info',
          component:device_info
        },
        {
          path:'orderTemp',
          name: 'device_orderTemp',
          component:device_orderTemp
        },
        {
          path:'info/:type/:isLightbox/:id?/:lightboxid?',
          name: 'device_Detail',
          component:device_Detail
        },
        {
          path:'order',
          name: 'device_order',
          component:device_order
        },
        {
          path:'orderdata/:deviceCode/:status?',
          name: 'device_order',
          component:device_order
        },
        {
          path:'realdata',
          name: 'device_realdata',
          component:device_realdata
        },
        {
          path:'getrealdata/:deviceCode?',
          name: 'device_realdata',
          component:device_realdata
        },
        {
          path:'version',
          name: 'device_version',
          component:device_version
        },
        {
          path:'version/:type/:id?',
          name: 'version_Detail',
          component:version_Detail
        },
        {
          path:'binddevice/:id?',
          name: 'Device_Binddevice',
          component:Device_Binddevice
        },
      ]
    },
    //------------------AD
    {
      path:'/ad/',
      name: 'ad',
      component: Console,
      children:[
        {
          path:'info',
          name: 'AD_info',
          component:AD_info
        },
        {
          path:'info/:type/:id?',
          name: 'AD_Detail',
          component:AD_Detail
        },
        {
          path:'bindcard/:id?',
          name: 'AD_Bindcard',
          component:AD_Bindcard
        },
        {
          path:'advertiser',
          name: 'AD_advertiser',
          component:AD_advertiser
        },
        {
          path:'advertiser/:type/:id?',
          name: 'advertiser_Detail',
          component:advertiser_Detail
        },
      ]
    },
    //------------------site
    {
      path:'/site/',
      name: 'site',
      component: Console,
      children:[
        {
          path:'info',
          name: 'site_info',
          component:site_info
        },
        {
          path:'info/:type/:id?',
          name: 'site_Detail',
          component:site_Detail
        },
        {
          path:'map',
          name: 'site_map',
          component:site_map
        },
        {
          path:'customsite',
          name: 'site_customsite',
          component:site_customsite
        },
        {
          path:'customlightbox/:id',
          name: 'site_customLightBox',
          component:site_customLightBox
        },
        {
          path:'customdevice/:id',
          name: 'site_customDevice',
          component:site_customDevice
        },
        
        {
          path:'customreport/:devicecode?',
          name: 'site_customReport',
          component:site_customReport
        }
      ]
    },
    //------------------lightbox
    {
      path:'/lightbox/',
      name: 'lightbox',
      component: Console,
      children:[
        {
          path:'info/',
          name: 'lightbox_info',
          component:lightbox_info
        },
        {
          path:'infoforsite/:id?/:lbcode?',
          name: 'lightbox_info',
          component:lightbox_info
        },
        {
          path:'info/:type/:id?',
          name: 'lightbox_Detail',
          component:lightbox_Detail
        },
        {
          path:'lightboxdevice/:id?',
          name: 'lightbox_Device',
          component:lightbox_Device
        },
        {
          path:'log/:devicecode?',
          name: 'lightbox_log',
          component:lightbox_log
        },
        {
          path:'checkup/',
          name: 'lightbox_checkup',
          component:lightbox_checkup
        },
        {
          path:'checkup/:type/:id?',
          name: 'lightbox_checkup_detail',
          component:lightbox_checkup_detail
        },
      ]
    },
    //----------------------Card
    {
      path:'/card/',
      name: 'card',
      component: Console,
      children:[
        {
          path:'info/',
          name: 'card_info',
          component:card_info
        },
        {
          path:'info/:type/:id?',
          name: 'card_Detail',
          component:card_Detail
        },
      ]
    },
    //---------------------Alert
    {
      path:'/alert/',
      name: 'alert',
      component: Console,
      children:[
        {
          path:'data/',
          name: 'Alert_Data',
          component:Alert_Data
        },
        {
          path:'config/',
          name: 'Alert_Config',
          component:Alert_Config
        },
        {
          path:'config/:type/:id?',
          name: 'Alert_Config_Detail',
          component:Alert_Config_Detail
        },
        {
          path:'configuser/:id?',
          name: 'Alert_Config_User',
          component:Alert_Config_User
        },
        {
          path:'log',
          name: 'Alert_Log',
          component:Alert_Log
        }
      ]
    },
    //---------------------flow
    {
      path:'/flow/',
      name: 'flow',
      component: Console,
      children:[
        {
          path:'data/',
          name: 'Flow_Data',
          component:Flow_Data
        },
        {
          path:'type/',
          name: 'Flow_type',
          component:Flow_type
        },{
          path:'type/:type/:id?',
          name: 'type_Detail',
          component:type_Detail
        }
      ]
    },
    //--------------------log
    {
      path:'/log/',
      name: 'log',
      component: Console,
      children:[
        {
          path:'worktime/',
          name: 'log_worktime',
          component:log_worktime
        }
      ]
    },
  ]
})
